export default {
  products: [],
  pagination: {},
  product: {}
}
